// The workspace the user last picked survives a reload (Bug 2793). It is a hint:
// useStore.init honours it only when /me still lists it, so a stale or foreign id
// is ignored rather than requested.
const WORKSPACE_KEY = 'conciliatron:workspace-id';

export function readRememberedWorkspace(): number | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(WORKSPACE_KEY);
    return raw != null && /^\d+$/.test(raw) ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function rememberWorkspace(workspaceId: number): void {
  try {
    window.localStorage.setItem(WORKSPACE_KEY, String(workspaceId));
  } catch {
    // Storage unavailable (private mode) — switching still works this session.
  }
}
